
function getTimestamp(offsetInSeconds?: number) {
	if (offsetInSeconds) {
		return Math.floor(Date.now() / 1000) + offsetInSeconds;
	}
	return Math.floor(Date.now() / 1000);
}

export default getTimestamp;